/**
 * Status badge — a colored dot + label.
 *
 * Variants: neutral | pending | success | danger
 */
export function Badge({ variant = "neutral", label }) {
  const el = document.createElement("span");
  el.className = `badge badge-${variant}`;

  const dot = document.createElement("span");
  dot.className = "dot";

  el.append(dot, document.createTextNode(label));
  return el;
}
